import { useApiQuery } from '@locus-taxy/encore-ui-network';

export interface AnalyticsDashboardGrantRule {
  permission_set?: string;
  [key: string]: unknown;
}

export interface AnalyticsDashboardAuthorizationDetail {
  resource_name?: string;
  resource_legacy_acl_path?: string;
  grant_rules?: AnalyticsDashboardGrantRule[];
  type?: string;
  [key: string]: unknown;
}

export interface AnalyticsDashboardTokenData {
  token?: string;
  access_token?: string;
  accessToken?: string;
  token_type?: string;
  tokenType?: string;
  expires_in?: number;
  expiresAt?: string;
  authorization_details?: AnalyticsDashboardAuthorizationDetail[];
  [key: string]: unknown;
}

export interface AnalyticsDashboardTokenResponse {
  data: AnalyticsDashboardTokenData;
  success: boolean;
}

export function useAnalyticsDashboardToken(
  clientId: string,
  dashboardId: string | null | undefined,
  options?: { enabled?: boolean }
) {
  return useApiQuery<AnalyticsDashboardTokenResponse>({
    key: ['analytics-dashboard-token', clientId, dashboardId ?? ''],
    endpointKey: 'analytics.dashboard.token',
    params: {
      clientId,
      dashboardId: dashboardId ?? '',
    },
    config: {
      method: 'POST',
      body: {},
      staleTime: 0,
      gcTime: 5 * 60 * 1000,
      enabled: Boolean(clientId && dashboardId) && (options?.enabled ?? true),
    },
  });
}
